import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, CardBody, Col, Container } from "reactstrap";
import InviteUsersTable from "../../Components/Tables/InviteUsersTable/InviteUsersTable";
import Loading from "../../Components/Loading";
import {
  getUserAccessInviteByDashboardUserId,
  removeAccessInvite,
  resendUserAccessInvitation,
} from "../../slices/general/thunk";
import { useDispatch } from "react-redux";
import InviteUserModal from "../../Components/modals/InviteUsersModal/InviteUsersModal";
import Swal from "sweetalert2";

const DashboardInviteUsers = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [modalInviteUser, setModalInviteUser] = useState(false);

  const toggleModalInviteUser = () => setModalInviteUser(!modalInviteUser);

  const [currentPage, setCurrentPage] = useState(0);
  const [users, setUsers] = useState([]);

  const [loading, setLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);

  const [totalUsers, setTotalUsers] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const fetchUserInvites = async () => {
    try {
      setLoading(true);
      const res = await dispatch(getUserAccessInviteByDashboardUserId());
      const response = res.payload;
      if (response && response.data) {
        setUsers(response.data);
        setTotalUsers(response.total);
        setPageSize(response.pageSize);
        setTotalPages(response.pages);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    fetchUserInvites();
  }, [currentPage]);

  const handleRemoveAccess = async (user) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to remove access to user " + user.email + "?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      });

      if (result.isConfirmed) {
        setLoading(true);
        const res = await dispatch(removeAccessInvite(user.id));
        const response = res.payload;

        if (response && !response.error) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Access removed successfully",
          });

          // Refreresh the table
          fetchUserInvites();
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.message || "An error occurred",
          });
        }
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred",
      });
    }
  };

  const handleResendInvitation = async (user) => {
    try {
      const result = await Swal.fire({
        title: "Resend Invitation",
        text: "Do you want to resend invitation to " + user.email + "?",
        icon: "",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: "Sending Invitation...",
          text: "Please wait while the invitation is being sent.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const response = await dispatch(
          resendUserAccessInvitation({ id: user.id })
        );

        if (response.error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "An error occurred",
          });
          throw new Error(response.error.message);
        }

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Invitation sent successfully",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred",
      });
    }
  };

  return (
    <div className="page-content px-0 ">
      <InviteUserModal
        open={modalInviteUser}
        setOpen={setModalInviteUser}
        onRefresh={fetchUserInvites}
      />
      <Container fluid>
        <Card>
          <CardBody>
            {" "}
            <div className="p-3 d-flex align-items-center justify-content-between">
              <div className="d-flex flex-column">
                <h3 className=" fw-bold  text-dark d-flex align-items-center">
                  <i
                    onClick={() => navigate("/profile")}
                    className="ri-arrow-left-s-line me-3 fs-3 cursor-pointer"
                  ></i>
                  Manage Users
                </h3>
              </div>
              <Button
                onClick={toggleModalInviteUser}
                color="soft-primary"
                size="md"
                className="py-2 d-flex align-items-center border border-primary"
              >
                <i className="ri-add-line me-2"></i> Invite Users
              </Button>
            </div>
          </CardBody>
        </Card>
        <Col xl={12} className="card">
          <div className="table-container card-body  position-relative">
            {loading && <Loading />}
            <div className="live-preview">
              <div className="table-responsive ">
                <InviteUsersTable
                  data={users}
                  onRemoveAccess={handleRemoveAccess}
                  onResendInvitation={handleResendInvitation}
                  searchDone={searchDone}
                  searchParam={searchTerm}
                  onRefresh={fetchUserInvites}
                  paginationProps={{
                    itemsCount: users.length,
                    totalPages: totalPages,
                    totalItems: totalUsers,
                    currentPage: currentPage,
                    onChangePage: handleChangePage,
                  }}
                />
              </div>
            </div>
          </div>
        </Col>
      </Container>
    </div>
  );
};

export default DashboardInviteUsers;
